export function whats() {
	window.open('https://wa.me/5215510695948', '_blank');
}
export function llamar() {
	window.open('tel:8003000268', '_blank');
}

export function openAppStore() {
	window.open(
		'https://apps.apple.com/mx/app/cmv-finanzas/id1459928515',
		'_blank'
	);
}
export function openPlayStore() {
	window.open(
		'https://play.google.com/store/apps/details?id=mx.com.cmv.finanzas',
		'_blank'
	);
}
